import { Reducer } from 'redux'
import { KANBAN, TYPES } from './types'
import { AnyAction } from 'models/types'

const INITIAL_STATE: KANBAN = {
  kanbanData: {
    columns: [
      {
        id: 1,
        title: 'Backlog',
        cards: [
          {
            id: 1,
            cpf: '12345678900',
            title: 'José da Silva',
            tag: 'INSS',
            badge: 'Alta',
            phone: '11999991234',
            email: 'jose.silva@email.com',
            value: 3200,
            time: '2025-09-08T11:00:00',
            borderColor: '#ff9800',
            priorityColor: '#f79a93ff',
            beneficioColor: '#1976d2'
          },
          {
            id: 2,
            cpf: '12345678900',
            title: 'Maria Oliveira',
            tag: 'FGTS',
            badge: 'Média',
            phone: '21988885678',
            email: 'maria.oliveira@email.com',
            value: 1500,
            time: '2025-09-08T11:30:00',
            borderColor: '#ffeb3b',
            priorityColor: '#fff7adff',
            beneficioColor: '#1976d2'
          }
        ]
      },
      {
        id: 2,
        title: 'Em Progresso',
        cards: [
          {
            id: 3,
            cpf: '12345678900',
            title: 'Carlos Santos',
            tag: 'Autônomo',
            badge: 'Baixa',
            phone: '31977771234',
            email: 'carlos.santos@email.com',
            value: 800,
            time: '2025-09-08T09:00:00',
            borderColor: '#2196f3',
            priorityColor: '#7fdb82ff',
            beneficioColor: '#1976d2'
          },
          {
            id: 4,
            cpf: '12345678900',
            title: 'Ana Paula',
            tag: 'INSS',
            badge: 'Alta',
            phone: '41966665678',
            email: 'ana.paula@email.com',
            value: 2000,
            time: '2025-09-08T10:00:00',
            borderColor: '#4caf50',
            priorityColor: '#f79a93ff',
            beneficioColor: '#1976d2'
          }
        ]
      },
      {
        id: 3,
        title: 'Concluído',
        cards: [
          {
            id: 5,
            cpf: '12345678900',
            title: 'Roberto Lima',
            tag: 'FGTS',
            badge: 'Média',
            phone: '51955551234',
            email: 'roberto.lima@email.com',
            value: 1200,
            time: '2025-01-08T15:00:00',
            borderColor: '#9c27b0',
            priorityColor: '#fff7adff',
            beneficioColor: '#1976d2'
          },
          {
            id: 6,
            cpf: '12345678900',
            title: 'Fernanda Costa',
            tag: 'Autônomo',
            badge: 'Baixa',
            phone: '61944445678',
            email: 'fernanda.costa@email.com',
            value: 900,
            time: '2025-05-02T15:00:00',
            borderColor: '#0d47a1',
            priorityColor: '#4caf50',
            beneficioColor: '#1976d2'
          }
        ]
      }
    ]
  }
}

const reducer: Reducer<KANBAN, AnyAction> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.SET_KANBAN:
      return { ...state, kanbanData: action.value }
    default:
      return state
  }
}

export default reducer
